import dynamic from 'next/dynamic';
import { ReturnLabelSpotProps } from './return-label-spot';

export const ReturnLabelSpot = dynamic<ReturnLabelSpotProps>(
    () => import('./return-label-spot').then((mod) => mod.ReturnLabelSpot),
    {
        ssr: false,
    }
);
